import { useQuery } from '@tanstack/react-query';

import { getFile } from '../endpoints/files';

// Presigned URLs expire server-side (PreviewUrlExpiration), so a cached URL older than this is re-fetched.
export const FILE_URL_FRESH_MS = 5 * 60 * 1000;

export const useFileQuery = ({
    fileId,
    refetchOnWindowFocus = false,
    staleTime,
}: {
    fileId: string;
    refetchOnWindowFocus?: boolean;
    staleTime?: number;
}) =>
    useQuery({
        queryKey: ['file', fileId],
        enabled: Boolean(fileId),
        refetchOnWindowFocus,
        staleTime,
        queryFn: async () => {
            return await getFile(fileId);
        },
    });
